<script lang="ts">
	import { onMount } from 'svelte';
	import { getOptimizedImageSet, getBlurHash } from './performantImage';

	export let image_url: string;
	export let alt = '...';
	export let borderClass: string = 'rounded-t-2xl';

	let imageLoaded = false;
	let imageError = false;
	let containerWidth: number;
	let imageRef: HTMLElement;

	$: optimizedImage =
		containerWidth && image_url ? getOptimizedImageSet(image_url) : { src: '', srcset: '' };

	$: blurHashUrl = image_url ? getBlurHash(image_url) : '';

	function handleImageError() {
		imageError = true;
		imageLoaded = true;
	}

	onMount(() => {
		const observer = new ResizeObserver((entries) => {
			containerWidth = entries[0].contentRect.width;
		});

		observer.observe(imageRef);
		return () => observer.disconnect();
	});
</script>

<div class={`relative w-full aspect-[16/9] overflow-hidden ${borderClass}`} bind:this={imageRef}>
	{#if !imageLoaded && !imageError && image_url}
		<img
			src={blurHashUrl}
			alt=""
			class="absolute inset-0 w-full h-full object-cover bg-cosmicPurplebg transition-opacity duration-300"
		/>
	{/if}

	{#if image_url}
		<picture>
			<img
				loading="lazy"
				decoding="async"
				class="absolute inset-0 w-full h-full object-cover bg-cosmicPurplebg transition-opacity duration-300"
				class:opacity-0={!imageLoaded}
				class:opacity-100={imageLoaded}
				src={optimizedImage.src}
				srcset={optimizedImage.srcset}
				sizes="(max-width: 300px) 300px,
					   (max-width: 400px) 400px,
					   600px"
				{alt}
				on:load={() => (imageLoaded = true)}
				on:error={handleImageError}
			/>
		</picture>
	{:else}
		<div class="absolute inset-0 w-full h-full bg-cosmicPurplebg flex items-center justify-center">
			<span class="text-gray-400">No image available</span>
		</div>
	{/if}
</div>
